import { render, staticRenderFns } from "./ticket-newuser-list.vue?vue&type=template&id=a200126a&"
import script from "./ticket-newuser-list.vue?vue&type=script&lang=js&"
export * from "./ticket-newuser-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports